import { FC, InputHTMLAttributes } from 'react';
import { UseFormRegister } from 'react-hook-form';

import { Input, InputError } from '../Input';

interface FormInputURLProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> {
  id: string;
  register: UseFormRegister<any>;
  isError: boolean;
  errorMessage: string;
  disabled: boolean;
}

export const FormInputURL: FC<FormInputURLProps> = ({
  id,
  register,
  isError,
  errorMessage,
  placeholder = "https://example.com/webhook",
  disabled,
}) => {
  return (
    <>
      <Input
        id={id}
        type="text"
        placeholder={placeholder}
        disabled={disabled}
        register={register(id, {
          required: true,
          pattern: {
            value: /^https:\/\/.+/,
            message: 'URL must start with https://'
          }
        })}
        isError={isError}
      />
      <InputError
        message={errorMessage}
        isError={isError}
      />
    </>
  );
};
